import * as Yup from 'yup';
import isEqual from 'date-fns/isEqual';
import { addressSchema } from '../components/SitePages/Transport/AddToExchange/validate';

// Helper to convert HH:MM string to minutes for comparison
const timeToMinutes = (time) => {
  if (!time) return null;
  const parts = time.split(':');
  const hours = parseInt(parts[0], 10) || 0;
  const minutes = parseInt(parts[1], 10) || 0;
  return hours * 60 + minutes;
};

export const freightsValidateSchema = (t) => {
  return Yup.object({
    weight: Yup.number().typeError(' ').required(t('required_text')),
    loading_date_from: Yup.date()
      .min(new Date(new Date().setHours(0, 0, 0, 0)), t('errors.dateLargeThanNow'))
      .required(t('required_text'))
      .typeError(t('must_be_date')),
    loading_date_to: Yup.date()
      .min(new Date(new Date().setHours(0, 0, 0, 0)), t('errors.dateLargeThanNow'))
      .typeError(t('must_be_date'))
      .nullable(),
    unloading_date_from: Yup.date()
      .min(new Date(new Date().setHours(0, 0, 0, 0)), t('errors.dateLargeThanNow'))
      .required(t('required_text'))
      .typeError(t('must_be_date')),
    unloading_date_to: Yup.date()
      .min(new Date(new Date().setHours(0, 0, 0, 0)), t('errors.dateLargeThanNow'))
      .required(t('required_text'))
      .typeError(t('must_be_date')),
    loading_time_from: Yup.string().nullable(),
    loading_time_to: Yup.string().nullable().test(
      'loading-time-order',
      t('errors.endLoadingGreaterStart'),
      function (value) {
        const { loading_time_from } = this.parent;
        if (!value || !loading_time_from) return true;
        const fromMinutes = timeToMinutes(loading_time_from);
        const toMinutes = timeToMinutes(value);
        if (fromMinutes === null || toMinutes === null) return true;
        return toMinutes >= fromMinutes;
      }
    ),
    unloading_time_from: Yup.string().nullable().test(
      'unloading-time-after-loading',
      t('errors.timeUnloadingGreaterLoading'),
      function (value) {
        const { loading_date, unloading_date_from, loading_time_to } = this.parent;
        if (!value || !loading_time_to) return true;
        if (!loading_date || !unloading_date_from) return true;
        if (!isEqual(new Date(loading_date), new Date(unloading_date_from))) return true;
        const loadingToMinutes = timeToMinutes(loading_time_to);
        const unloadingFromMinutes = timeToMinutes(value);
        if (loadingToMinutes === null || unloadingFromMinutes === null) return true;
        return unloadingFromMinutes >= loadingToMinutes;
      }
    ),
    unloading_time_to: Yup.string().nullable().test(
      'unloading-time-order',
      t('errors.endUnloadingGreaterStart'),
      function (value) {
        const { unloading_time_from } = this.parent;
        if (!value || !unloading_time_from) return true;
        const fromMinutes = timeToMinutes(unloading_time_from);
        const toMinutes = timeToMinutes(value);
        if (fromMinutes === null || toMinutes === null) return true;
        return toMinutes >= fromMinutes;
      }
    ),
    cargo_designations_id: Yup.mixed().test(
      'cargo-designation-required',
      t('required_text'),
      function (value) {
        const { cargo_designations_additional } = this.parent;
        // At least one field must be filled
        // Show error only on cargo_designations_id if both are empty
        if (!value && !cargo_designations_additional) {
          return false;
        }
        return true;
      }
    ),
    cargo_designations_additional: Yup.mixed().nullable(),
    transport_bodytype_ids: Yup.mixed().required(t('required_text')),
    loading_types_ids: Yup.mixed(),
    unloading_types_ids: Yup.mixed(),
    loading_address: addressSchema(t),
    unloading_address: addressSchema(t),
    currency_id: Yup.mixed().required(t('required_text')),
    price: Yup.string().required(t('required_text')),
    width: Yup.number().typeError(' ').positive(' '),
    height: Yup.number().typeError(' ').positive(' '),
    length: Yup.number().typeError(' ').positive(' '),
    diameter: Yup.number().typeError(' ').positive(' '),
    volume: Yup.number().typeError(' ').positive(' '),
    is_vat_included: Yup.boolean(),
    gps_tracking: Yup.boolean(),
  });
};

export const auctionValidateSchema = (t) =>
  freightsValidateSchema(t).concat(
    Yup.object({
      expires: Yup.date().required(t('required_text')),
    }),
  );

// TODO delete it
export const freightsInitialValues = {
  weight: '',
  loading_date_from: '',
  loading_date_to: '',
  unloading_date_from: '',
  unloading_date_to: '',
  cargo_designations_id: '',
  transport_bodytype_ids: [],
  loading_types_ids: '',
  unloading_types_ids: '',
  loading_address: '',
  unloading_address: '',
  is_other: false,
  round_trip: false,
  modular_cargo: false,
  hitch: false,
  air_passage: false,
  conics: false,
  tir: false,
  cmr: false,
  t1: false,
  medical_book: false,
  round_clock1: false,
  round_clock2: false,
  fuel_prepayment: false,
  upload: false,
  direct_contract: false,
  price: '',
  currency_id: '',
  count: '',
  belts: '',
};
